<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="configNotificacoes.content"
      class="elevation-0 mt-5"
      :loading="loading"
      :server-items-length="configNotificacoes.total"
      hide-default-footer
      no-data-text="Nenhuma configuração de notificação encontrada"
      loading-text="Carregando configurações de notificações..."
      :options="optionsList"
    >
      <template v-slot:item.notificacao="{ item }">
        <px-tipo-notificacao :tipo-notificacao="item.tipoNotificacao"/>
      </template>
      <template v-slot:item.whatsapp="{ item }">
        <div class="d-flex justify-center">
          <v-checkbox v-model="item.whatsapp"
                      :true-value="false"
                      :false-value="true"
                      @change="saveNotification(item)"/>
        </div>
      </template>
      <template v-slot:item.email="{ item }">
        <div class="d-flex justify-center">
          <v-checkbox v-model="item.email"
                      :true-value="false"
                      :false-value="true"
                      @change="saveNotification(item)"/>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import NotificacaoService from './config-notificacao-service';

export default {
  props: {
    configNotificacoes: Object,
    default: [],
    loading: Boolean,
    optionsList: Object,
  },
  data() {
    return {
      headers: [
        {
          text: 'Tipo notificação',
          value: 'notificacao',
          sortable: false,
        },
        {
          text: 'Whatsapp',
          value: 'whatsapp',
          align: 'center',
          sortable: false,
        },
        {
          text: 'E-mail',
          value: 'email',
          align: 'center',
          sortable: false,
        },
      ],
    };
  },
  methods: {
    saveNotification(notification) {
      NotificacaoService.create(notification)
        .then(() => {
          this.$emit('update');
          this.$toast('Notificação atualizada', { color: 'success' });
        });
    },
  },
};
</script>
